export default __webpack_public_path__ + "eecd95594997940122655df398ebabde.svg";